export enum BS_SUB_STATUS {
    BS_6M_MISSING = "BS_6M_MISSING",
    BS_SALARY_MISSING = "BS_SALARY_MISSING",
    BS_NET_BANKING = "BS_NET_BANKING",
    BS_PDF_NET_AA = "BS_PDF_NET_AA",
    BS_NET_PDF = "BS_NET_PDF"
}
